module.exports = __webpack_public_path__ + "static/media/logo_flickread.6123c16d.png";